<template>
    <kimsa-select :items="clients" item-text="name" item-value="id" label="Seleccionar cliente" :value="clientId"
        @change="onChangeClientId" outlined solo flat dense forceValue bolderLabel />
</template>

<script>
import { mapMutations, mapState } from 'vuex/dist/vuex.common.js';
import KimsaSelect from './KimsaSelect.vue';

export default {
    components: { KimsaSelect },
    name: 'SetCurrentClientInput',
    data() {
        return {
            clientId: null,
        }
    },
    computed: {
        ...mapState(['currentClientId']),
        clients() {
            return this.account?.clients || []
        },
    },
    mounted() {
        const clientId = Number(this.currentClientId) || this.clients?.[0]?.id || null
        this.onChangeClientId(clientId)
    },
    methods: {
        ...mapMutations(['setCurrentClientId']),
        onChangeClientId(clientId) {
            if (clientId) {
                this.clientId = clientId
                this.setCurrentClientId(clientId)
            }
        },
    }
}
</script>

<style></style>